import moment from 'moment';

export const prepareOverviewSettings = (payload: any) => {
  const detailed_metrics = payload.find(
    (node: any) => node.resource_name === 'overview_detailed_metrics'
  );
  const global_metrics = payload.find(
    (node: any) => node.resource_name === 'overview_global_metrics'
  );
  return {
    detailed_metrics: {
      ...detailed_metrics?.settings,
      resource_id: detailed_metrics?.resource_id,
      main_kpi: detailed_metrics?.settings?.main_kpi ?? 'cpc',
      main_kpi_sort:
        detailed_metrics?.settings?.main_kpi_sort.toUpperCase() ?? 'ASC'
    },
    global_metrics: {
      resource_id: global_metrics?.resource_id,
      ...global_metrics?.settings
    }
  };
};

export const prepareVrrSettings = (payload: any) => {
  return {
    ...payload?.settings,
    resource_id: payload?.resource_id,
    period: {
      from: payload.settings?.period?.from ?? moment(),
      to: payload.settings?.period?.to ?? moment()
    }
  };
};

export const prepareNodeOverviewSettings = (payload: any) => {
  const node = payload.resource_name.replace(/^overview_/, '');

  if (node === 'detailed_metrics') {
    return {
      detailed_metrics: {
        ...payload?.settings,
        resource_id: payload?.resource_id,
        main_kpi: payload?.settings?.main_kpi ?? 'cpc',
        main_kpi_sort: payload?.settings?.main_kpi_sort.toUpperCase() ?? 'ASC'
      }
    };
  }
  return {
    [node]: {
      resource_id: payload?.resource_id,
      ...payload?.settings
    }
  };
};

export const prepareInsightsSettings = (payload: any) => {
  return {
    ...payload?.settings,
    resource_id: payload?.resource_id
  };
};
